import styled from "styled-components";

export const ModeSwitch = styled.div`
    margin: 14px 0;

    & .ant-select {
        margin-top: 10px;
    }
`;
